// extracted by mini-css-extract-plugin
export default {"root":"EditListingQuoteDetailsPanel_root__G1TvM","form":"EditListingQuoteDetailsPanel_form__eEUa6","title":"EditListingQuoteDetailsPanel_title__M+vFs"};